import { URLs, Contacts, systemNames } from '@it/orpk-vue-ts'
import { baseURL, clientBase } from '@/api/httpAxios'

export const productionURL = URLs.productionURL
export const devProductionURL = URLs.devProductionURL

export const supportEmail = Contacts.supportEmail
export const publicationOfficeEmail = 'pubo@etu.ru'

export const wikiURL = Contacts.wikiURL

export const wikiPage = Contacts.wikiPage

export const lkETUName = systemNames.lk.auth

export const isDev = process.env.NODE_ENV !== 'production'
export const isProduction = !isDev

export const authBase = `${baseURL}/auth/etuid/`
export const authDevBase = `${baseURL}/auth/dev`

export const clientBaseWithSlash = clientBase + '/'

export const vueDevToolsURL = URLs.vueDevToolsURL

export const metabaseURL = `${productionURL}/metabase/`
